<!-- @if (categories().length > 1) {
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="end"
    animationDuration="0ms"
    [selectedIndex]="activeTab()"
    (selectedTabChange)="tabChange.emit($event.index)"
  >
    @for (category of categories(); track category.id) {
      <mat-tab [label]="category.name">
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </mat-tab>
    }
  </mat-tab-group>

  <ng-template #tabContent></ng-template>
} -->

@if (tournamentCategory(); as tc) {
  <tournament-category-ui
    [tournament]="tournament()"
    [categories]="categories()"
    [activeTab]="activeTab()"
    (tabChange)="tabChange.emit($event)"

    [tournamentCategory]="tc"
    [drawings]="drawings()"
    [games]="games()"
    [groupsRankings]="groupsRankings()"
    [eventsRankings]="eventsRankings()"
  ></tournament-category-ui>
}
